import { initializeAnalytics } from '@/core/analytics';
import { initializeRum } from '@/core/monitoring/rum';
import { authManager } from './core/auth';

authManager.login(async () => {
  initializeRum();
  await initializeAnalytics();

  const mainApp = await import('@/main-app');
  await mainApp.initMainApp();
});
